import styled from "styled-components/macro";

export const TableHeadStyled = styled.th<{ textAlign?: string }>`
  color: ${(props) => props.theme.palette.white};
  font-family: ${(props) => props.theme.font.arialBlack};
  font-size: 1.8rem;
  padding: 2rem 0;
  text-align: ${(props) => (props.textAlign ? props.textAlign : "center")};
`;
